export default __webpack_public_path__ + "static/media/card-finance.4f136a21.png";